module.exports = __webpack_public_path__ + "static/media/6.15fa2f1c.jpg";